import { Type } from "class-transformer";
import { CallCenterTicketSummaryListOutDTO } from "./call-center-ticket-summary-list.out.dto";

export class CallCenterTicketPaginatedOutDTO {
  @Type(() => CallCenterTicketSummaryListOutDTO)
  tickets!: CallCenterTicketSummaryListOutDTO[];

  total!: number;
}
